import styled from "styled-components/macro";
import { NavLink } from "react-router-dom";
import { ViewHeader, ViewText } from "../../components/ViewStyle/ViewStyle";
import { Box, Button, Card, CardBody, Center, Link } from "@chakra-ui/react";
import { useFetchQuery } from "../../hooks/useFetchQuery";

export const Content = styled.div`
  height: auto;
  width: 100%;
  max-width: 900px;
  background-color: white;
  border-radius: 10px;
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  gap: 5px;
`;

export default function PossibilityBox({
  manifestData,
  anchorID,
}: Record<string, any>): JSX.Element {
  const box = manifestData?.["views"]["possibilityBox"];
  const config = box?.["config"];
  const link = box?.["url"];
  const queryKey = anchorID;

  // get data
  const { data } = useFetchQuery(queryKey, link);
  const boxData = data.data;
  return (
    <section
      id={anchorID}
      aria-labelledby="possibilitybox-main"
      style={{
        backgroundColor: config.bgColor,
        padding: "1rem",
      }}
    >
      <Box
        maxWidth="1100px"
        margin="auto"
      >
        <ViewHeader
          role="heading"
          id="possibilitybox-main"
          titleColor={config?.titleColor}
        >
          {box?.title}
        </ViewHeader>
        <Card
          bg="white"
          marginY="1rem"
          paddingTop="1rem"
        >
          <CardBody>
            <ViewText
              textColor="black"
              dangerouslySetInnerHTML={{ __html: boxData?.content }}
            />
          </CardBody>
        </Card>
        <Center>
          {box?.external === true ? (
            <Link
              href={config?.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                size="lg"
                marginTop="15px"
                background={config?.buttonColor}
                color={config?.buttonTextColor}
              >
                {config?.buttonText.toUpperCase()}
              </Button>
            </Link>
          ) : (
            <NavLink to={config?.feature}>
              <Button
                size="lg"
                marginTop="15px"
                background={config?.buttonColor}
                color={config?.buttonTextColor}
              >
                {config.buttonText.toUpperCase()}
              </Button>
            </NavLink>
          )}
        </Center>
      </Box>
    </section>
  );
}
